import { SwipeableDrawer } from "@mui/material";
import { EGIconButton } from "../../../../MainComponents/Button/IconButton/IconButton";

export const DrawerContainer = ({
  children,
  open,
  onClose,
  borderColor = "ethicsBlue.main",
}) => {
  return (
    <SwipeableDrawer
      anchor="right"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      keepMounted
      sx={{ zIndex: 1080 }}
      ModalProps={{
        slotProps: {
          backdrop: {
            sx: {
              backdropFilter: "blur(1px)",
              backgroundColor: "rgba(0, 0, 0, 0.2)",
              transition: open ? "all 0.3s ease-in-out" : "none",
            },
          },
        },
      }}
      PaperProps={{
        sx: {
          maxWidth: "390px",
          width: "100%",
          borderWidth: "2px",
          borderStyle: "solid",
          borderColor,
        },
      }}
    >
      <EGIconButton
        iconName="cancel_circle"
        onClick={onClose}
        iconColor="primary"
        sx={{ position: "absolute", top: 6, right: 6 }}
      />
      {children}
    </SwipeableDrawer>
  );
};
